export default __webpack_public_path__ + "static/media/highpark.caa29912.png";